import React, {Fragment, PureComponent, useCallback, useState} from 'react';
import {connect, useSelector, useDispatch} from 'react-redux';
import {setSubmitted, showAddressForm} from '../../actions/ui';
import {addFamilyMember, setFamilyMembers} from '../../actions/familyMembers';
import {getMaritalStatuses} from '../../actions/maritalStatuses';
import MeForm from './forms/MeForm';
import SpouseForm from './forms/SpouseForm';
import FamilyMemberForm from './forms/FamilyMemberForm';
import AddressForm from './forms/AddressForm';
import CongregationForm from './forms/CongregationForm';
import Field from '../Field';
import TextAreaInput from '../TextAreaInput';
import TextInput from '../TextInput';
import BooleanInput from '../BooleanInput';
import values from 'object-values';
import {
  setComments,
  setVisitReminderEmail,
  setVehicleMake,
  setVehicleModel,
  setVehicleColor
} from '../../actions/visit';
import './index.less';


function CommentsField() {
  const value = useSelector(state => state.visit.comments);
  const dispatch = useDispatch();

  const onChange = useCallback(value => {
    dispatch(setComments(value));
  });

  const setErrors = useCallback(event => {});

  return (
    <Field label="Comments..."
        value={value} onChange={onChange} errors={[]}
        setErrors={setErrors}
        style={{marginTop: 68}}>
      <TextAreaInput />
    </Field>
  );
}


function HelpUsFindYou() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const toggleShow = useCallback(event => {
    setShow(show => !show);
  });

  const {make, model, color} = useSelector(state => ({
    make: state.visit.vehicle.make,
    model: state.visit.vehicle.model,
    color: state.visit.vehicle.color
  }));

  const setErrors = useCallback(() => {

  });

  const setMake = useCallback(value => {
    dispatch(setVehicleMake(value));
  });

  const setModel = useCallback(value => {
    dispatch(setVehicleModel(value));
  });

  const setColor = useCallback(value => {
    dispatch(setVehicleColor(value));
  });

  return (
    <Fragment>
      <div className="field">
        <label className="help-us-find-you" style={{
          color: '#6D757B',
          textTransform: 'none',
          fontSize: 14,
          marginBottom: 10
        }}>We'd love to welcome you as soon as you get here. Can we keep an eye out for your car?</label>
      </div>
      <div className="horizontal-field-group">
        <Field
            label="Make"
            value={make}
            onChange={setMake}
            setErrors={setErrors}
            errors={[]}>
          <TextInput />
        </Field>
        <Field
            label="Model"
            value={model}
            onChange={setModel}
            setErrors={setErrors}
            errors={[]}>
          <TextInput />
        </Field>
        <Field
            label="Color"
            value={color}
            onChange={setColor}
            setErrors={setErrors}
            errors={[]}>
          <TextInput />
        </Field>
      </div>
    </Fragment>
  );
}


function EmailReminderField() {
  const value = useSelector(state => state.visit.reminderEmail);
  const dispatch = useDispatch();

  const onChange = useCallback(value => {
    dispatch(setVisitReminderEmail(value));
  });

  const setErrors = useCallback(() => {});

  return (
    <Field
        label="Would you like to receive a reminder email?"
        showLabel
        value={value}
        onChange={onChange}
        setErrors={setErrors}
        errors={[]}
        style={{
          //marginTop: 68,
          maxWidth: 1200,
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
      <BooleanInput>Yes</BooleanInput>
    </Field>
  );
}


@connect(
  state => {
    let meErrors = values(state.me)
      .map(i => i.errors)
      .reduce((a, b) => a.concat(b), []);
    let spouseErrors = values(state.spouse)
      .map(i => i.errors)
      .reduce((a, b) => a.concat(b), []);
    let familyMemberErrors = state.familyMembers.ids
      .map(i => (
        values(state.familyMembers.byId[i])
        .map(i => i.errors)
        .reduce((a, b) => a.concat(b), [])
      ))
      .reduce((a, b) => a.concat(b), []);
    let addressErrors = values(state.address)
      .map(i => i.errors)
      .reduce((a, b) => a.concat(b), []);
    let congregationErrors = state.congregations.errors;

    let showSpouseForm = state.me.Marital_Status_ID.value === 2;

    return {
      hasErrors: meErrors.length > 0 || 
        (showSpouseForm && spouseErrors.length > 0) ||
        (familyMemberErrors.length > 0) ||
        (state.ui.showAddressForm && addressErrors.length > 0) ||
        congregationErrors.length > 0,
      showSpouseForm: showSpouseForm,
      showAddressForm: state.ui.showAddressForm,
      familyMembers: state.familyMembers.ids
    };
  },
  dispatch => ({
    setSubmitted(submitted) {
      dispatch(setSubmitted(submitted));
    },
    setShowAddressForm() {
      dispatch(showAddressForm());
    },
    addFamilyMember() {
      dispatch(addFamilyMember());
    },
    setFamilyMembers(numMembers) {
      dispatch(setFamilyMembers(numMembers));
    },
    getMaritalStatuses() {
      dispatch(getMaritalStatuses());
    }
  })
)
export default class FormRoute extends PureComponent {
  state = {
    showChildren: false
  };

  componentDidMount() {
    this.props.getMaritalStatuses();
  }

  render() {
    let {
      showSpouseForm, showAddressForm, setShowAddressForm,
      addFamilyMember, familyMembers
    } = this.props;
    const {showChildren} = this.state;

    return (
      <div className="route form-route">
        <form onSubmit={this._onSubmit} noValidate>
          <div className="congregation">
            <CongregationForm />
          </div>
          <h3 className="campus-text">Tell us about you and your family</h3>
          <div className="heads-of-household">
            <MeForm />
            {showSpouseForm && <SpouseForm />}
          </div>
          <div className="field">
            <label className="campus-text">Are there children in your group?</label>
            <div className="input">
              <input type="checkbox" checked={showChildren} onChange={this._onShowChildren}
                  id='show-children' />
              <label htmlFor='show-children'>Yes</label>
            </div>
          </div>
          {showChildren &&
            <Fragment>
              <div className="add-family-member">
                <button type="button" onClick={() => addFamilyMember()}
                    className="campus-text campus-border">Add Child</button>
              </div>
              <div className="family-members" style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: 1200
              }}>
                {familyMembers.map(i =>
                  <FamilyMemberForm key={i} id={i} hideRemove={familyMembers.length === 1} />
                )}
              </div>
            </Fragment>
          }
          <EmailReminderField />
          <HelpUsFindYou />
          <CommentsField />
          <div className="form-controls">
            <button type="submit" className="campus-background campus-border">Submit</button>
          </div>
        </form>
      </div>
    );
  }

  _onShowChildren = event => {
    const {showChildren} = this.state;
    this.setState({showChildren: !showChildren});
    if (showChildren) {
      this.props.setFamilyMembers(0);
    }
    else {
      this.props.setFamilyMembers(1);
    }
  };

  _onSubmit = (event) => {
    event.preventDefault();

    if (this.props.hasErrors) {
      this.props.setSubmitted(true);
    }
    else {
      this.props.history.push('/submit');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/form-route/index.js